
/**
 * PropertySelectField - Reusable select/dropdown field for garden object properties
 *
 * @param {string} label - Field label
 * @param {string} value - Current value
 * @param {function} onChange - Callback(newValue) when value changes
 * @param {Array} options - Array of {value, label} options
 * @param {boolean} disabled - Whether field is disabled
 */
const PropertySelectField = ({
  label,
  value,
  onChange,
  options = [],
  disabled = false,
}) => {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        {label}
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded
          focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500
          disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PropertySelectField;
